import script from "./BookingBrief.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingBrief.vue?vue&type=script&setup=true&lang=js"

import "./BookingBrief.vue?vue&type=style&index=0&id=340fdf8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340fdf8a"]])

export default __exports__